<template>
  <div class="bg" :style="{ background: '#' + background }">
    <div
      class="curve"
      v-bind:class="location"
      :style="{ background: '#' + foreground }"
    ></div>
  </div>
</template>

<style scoped>
.curve {
  height: 70px;
  background: #fff;
}

.bottomLeft {
  border-bottom-left-radius: 70px;
}

.topLeft {
  border-top-left-radius: 70px;
}

.topRight {
  border-top-right-radius: 70px;
}

.bottomRight {
  border-bottom-right-radius: 70px;
}
</style>

<script>
export default {
  props: ["location", "background", "foreground"]
};
</script>
